import {action, observable} from 'mobx';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import InterviewInvite from 'main/stores/recruiting/InterviewInvite';
import {successAlert, redirect} from 'shared/tools';

class InterviewInviteModalState {
  store = new DomainStore();

  @observable interviewInvite = new InterviewInvite();
  @observable scheduleInterviewErrors = {};
  @observable candidate;
  @observable interviewSchedules = [];
  @observable loadCandidate;
  @observable onClose;

  receiveProps({candidate, interviewSchedules, loadCandidate, onClose}) {
    this.candidate = candidate;
    this.interviewSchedules = interviewSchedules;
    this.loadCandidate = loadCandidate;
    this.onClose = onClose;
    this.interviewInvite.candidate = candidate;
  }

  @action selectInterviewSchedule(schedule) {
    this.interviewInvite.interviewSchedule = schedule;
    this.interviewInvite.startDate = schedule.resolvedStartDate;
    this.interviewInvite.endDate = schedule.resolvedEndDate;
  }

  @action createNewInterviewSchedule() {
    // Placeholder: the interview schedule creation flow is not built yet.
    redirect('/recruiting/interview-schedules/edit/');
  }

  @action async saveInterviewInvite() {
    const {model, errors} = await this.store.post(
      endpoints.INTERVIEW_INVITES,
      types.INTERVIEW_INVITE,
      this.interviewInvite
    );

    this.scheduleInterviewErrors = errors;
    if (model) {
      successAlert(t('recruiting.alerts.Interview invite sent'));
      await this.loadCandidate();
      this.onClose();
    }
  }
}

export default InterviewInviteModalState;
